import React from 'react';

const TimeSlotSelector = ({
  timeSlots = [],
  selectedTime = "",
  onTimeSelect,
  slotAvailability = {},
  selectedColor = "bg-[#769B40]",
  buttonClasses = "",
  tooltipText = "cupos disponibles",
  tooltip = "true",
  classname
}) => {
  return (
    <>
      {timeSlots.map((time, index) => {
        const availableSlots = slotAvailability[time] || 3; 
        const isSelected = selectedTime === time;
        
        return (
          <div className={`relative group ${classname}`} key={index}>
            <button
              className={`font-robotoregular text-white p-[8px] text-[14px] rounded-[8px] transition-opacity duration-300 ${
                isSelected ? selectedColor : 'bg-[#6B7280]'
              } ${buttonClasses}`}
              onClick={() => onTimeSelect(time)}
            >
              {time}
            </button>
            
            {/* Tooltip */}
            { tooltip && (
            <div className="absolute duration-300 opacity-0 left-2 -top-12 drop-shadow-md group-hover:opacity-100">
              <div className="bg-[#9b9a9a] w-[68px] rounded-[4px] px-2 p-1">
                <p className="text-white font-itcmedium text-[10px]">
                  {availableSlots} {tooltipText}
                </p>
              </div>
              <div className="w-0 h-0 drop-shadow-sm ml-1 border-l-[8px] border-r-[8px] border-b-[10.49px] rotate-180 border-l-transparent border-r-transparent border-b-[#9b9a9a]"></div>
            </div>
            )}

          </div>
        );
      })}
    </>
  );
};

export default TimeSlotSelector;